module.exports = __webpack_public_path__ + "img/MX.57baf107.png";